const MAIN_ASSET_PATTERN = /\/static\/js\/main\.[^/]+\.js$/;

export const APP_UPDATE_CHECK_INTERVAL = 5 * 60 * 1000;

export function normalizeAssetPath(assetUrl, baseUrl = window.location.href) {
  if (!assetUrl) {
    return null;
  }

  try {
    return new URL(assetUrl, baseUrl).pathname;
  } catch (e) {
    return assetUrl.split(/[?#]/)[0];
  }
}

export function getCurrentMainAsset(documentRef = document) {
  const script = Array.from(documentRef.scripts).find(({ src }) => {
    return MAIN_ASSET_PATTERN.test(normalizeAssetPath(src));
  });

  return script ? normalizeAssetPath(script.src) : null;
}

export function getManifestUrl(publicUrl = process.env.PUBLIC_URL || "") {
  const normalizedPublicUrl = publicUrl.replace(/\/$/, "");
  return `${normalizedPublicUrl}/asset-manifest.json`;
}

export async function getLatestMainAsset({
  fetcher = window.fetch.bind(window),
  manifestUrl = getManifestUrl(),
} = {}) {
  const response = await fetcher(manifestUrl, { cache: "no-store" });

  if (!response.ok) {
    return null;
  }

  const manifest = await response.json();
  return normalizeAssetPath(manifest["main.js"]);
}

export function isNewBuildAvailable(currentAsset, latestAsset) {
  return Boolean(currentAsset && latestAsset && currentAsset !== latestAsset);
}
